import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { 
  Gift, 
  ArrowLeft,
  ArrowRight,
  Loader2,
  AlertCircle,
  CheckCircle,
  ExternalLink,
  Download,
  Filter,
  X,
  Palmtree,
  Bus,
  Hotel,
  Tent,
  GraduationCap,
  Waves,
  Shirt,
  Dumbbell,
  User,
  MapPin,
  Briefcase,
  Wallet,
  Plane,
  Search,
  Sparkles,
  Star,
  TrendingUp,
  Eye,
  Lock,
  HelpCircle,
  KeyRound
} from 'lucide-react';
import { UserHeader } from '../components/UserHeader';
import HeroBannerTS from '../components/beneficios/HeroBannerTS';
import AccesosRapidos from '../components/beneficios/AccesosRapidos';
import CategoriasCarrusel from '../components/beneficios/CategoriasCarrusel';
import PrestadorCardBonda from '../components/beneficios/PrestadorCardBonda';
import PrestadorCardSkeleton from '../components/beneficios/PrestadorCardSkeleton';
import UnlockBeneficiosModal from '../components/beneficios/UnlockBeneficiosModal';
import { useAuth } from '../contexts/AuthContext';
import { fechaToInput, fechaToDisplay } from '../utils/fechaUtils';
import { TITULOS_VIGENTES, TITULOS_ANTERIORES } from '../constants/titulos';
import { goBack } from '../utils/navigation';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Mapeo de iconos
const iconMap = {
  Palmtree: Palmtree,
  Bus: Bus,
  Hotel: Hotel,
  Tent: Tent,
  GraduationCap: GraduationCap,
  Waves: Waves,
  Shirt: Shirt,
  Dumbbell: Dumbbell,
  Plane: Plane,
};

const GENEROS = [
  "Masculino",
  "Femenino", 
  "Feminidad trans/travesti",
  "Varón trans/masculinidad trans",
  "No binarie",
  "Otro"
];

export default function BeneficiosTSPage() {
  const navigate = useNavigate();
  const { isAuthenticated, user, trabajador } = useAuth();
  const [paso, setPaso] = useState(0); // 0=cargando, 1=login, 2=completar datos, 3=verificando, 4=sin_acceso, 5=guia
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Paso 1: Datos de login (solo si no está logueado)
  const [matricula, setMatricula] = useState('');
  const [documento, setDocumento] = useState('');
  
  // Paso 2: Formulario de datos completos (idéntico a EditarDatosPage)
  const [formData, setFormData] = useState({
    numero_matricula: '',
    documento: '',
    apellido: '',
    nombre: '',
    fecha_nacimiento: '',
    genero: '',
    titulo: '',
    email: '',
    celular: '',
    domicilio_real: { calle: '', numero: '', piso: '', depto: '', localidad: '' },
    domicilio_laboral: { calle: '', numero: '', piso: '', depto: '', localidad: '' },
    sin_empleo: false
  });
  
  const updateDomicilio = (tipo, field, value) => {
    setFormData(prev => ({
      ...prev,
      [tipo]: { ...prev[tipo], [field]: value }
    }));
  };
  
  // Datos del usuario verificado
  const [usuario, setUsuario] = useState(null);
  const [mensajeDeuda, setMensajeDeuda] = useState(null);
  
  // Datos de la guía
  const [categorias, setCategorias] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [populares, setPopulares] = useState([]);
  const [destacados, setDestacados] = useState([]);
  const [categoriaFiltro, setCategoriaFiltro] = useState(null);
  const [provinciaFiltro, setProvinciaFiltro] = useState(null);
  const [localidadFiltro, setLocalidadFiltro] = useState(null);
  const [origenFiltro, setOrigenFiltro] = useState(null); // 'rueda_turismo' | 'directo' | null
  const [generandoVoucher, setGenerandoVoucher] = useState(null);
  
  // Refs para scroll a secciones (accesos rápidos)
  const novedadesRef = React.useRef(null);
  const destacadosRef = React.useRef(null);
  const popularesRef = React.useRef(null);
  const listaCompletaRef = React.useRef(null);
  
  // Modal código de descuento
  const [showCodigoModal, setShowCodigoModal] = useState(false);
  const [codigoDescuento, setCodigoDescuento] = useState(null);
  const [vinculando, setVinculando] = useState(false);
  
  // Buscador
  const [busqueda, setBusqueda] = useState('');

  // Modal para desbloqueo (verificar matrícula)
  const [showUnlockModal, setShowUnlockModal] = useState(false);

  // Loading state para la guía (categorías + prestadores + curados)
  const [loadingDatos, setLoadingDatos] = useState(true);

  // Al montar, verificar si el usuario ya está logueado y tiene los datos necesarios
  useEffect(() => {
    const inicializar = async () => {
      // Bypass para admins/superadmins: acceso directo sin verificar matrícula/estado
      if (isAuthenticated && user && ['admin', 'superadmin', 'administracion'].includes(user.rol)) {
        const adminUser = {
          id: user.id,
          nombre: user.nombre || user.email || 'Administrador',
          matricula: user.rol === 'superadmin' ? 'SUPERADMIN' : 'ADMIN',
          documento: user.dni || '',
          es_admin: true,
          al_dia: true,
        };
        setUsuario(adminUser);
        sessionStorage.setItem('beneficios_usuario', JSON.stringify(adminUser));
        cargarDatosGuia();
        setPaso(5);
        return;
      }

      // Primero verificar si hay sesión guardada de beneficios (para usuarios no logueados)
      const usuarioGuardado = sessionStorage.getItem('beneficios_usuario');
      if (usuarioGuardado) {
        try {
          const datos = JSON.parse(usuarioGuardado);
          setUsuario(datos);
          setFormData(prev => ({
            ...prev,
            numero_matricula: datos.matricula || '',
            documento: datos.documento || ''
          }));
          cargarDatosGuia();
          setPaso(5);
          return;
        } catch (e) {
          sessionStorage.removeItem('beneficios_usuario');
        }
      }

      // Si el usuario está logueado en el sistema, usar sus datos automáticamente
      if (isAuthenticated && trabajador) {
        const mat = trabajador.numero_matricula || trabajador.matricula;
        const doc = trabajador.documento;
        const fechaNac = trabajador.fecha_nacimiento;
        
        if (mat && doc && fechaNac) {
          // Tiene todos los datos necesarios, verificar directamente en ANTUAR
          setMatricula(mat);
          setDocumento(doc);
          setFormData(prev => ({
            ...prev,
            numero_matricula: mat,
            documento: doc,
            fecha_nacimiento: fechaToInput(fechaNac),
            nombre: trabajador.nombre || '',
            apellido: trabajador.apellido || '',
            email: trabajador.email || '',
            celular: trabajador.celular || '',
            genero: trabajador.genero || '',
            titulo: trabajador.titulo || ''
          }));
          setPaso(3); // Ir a verificar
          await verificarEnAntuar(mat, doc);
          return;
        } else if (mat && doc) {
          // Tiene matrícula y documento pero falta fecha de nacimiento
          setMatricula(mat);
          setDocumento(doc);
          setFormData(prev => ({
            ...prev,
            numero_matricula: mat,
            documento: doc,
            nombre: trabajador.nombre || '',
            apellido: trabajador.apellido || ''
          }));
          setPaso(2); // Ir a completar datos
          return;
        }
      }
      
      // Si no está logueado o no tiene datos, mostrar la guía en modo PÚBLICO (sin acceso)
      // El usuario puede navegar libremente y ver "lo que se pierde".
      // Los CTAs bloqueados abrirán el modal para verificar matrícula.
      setUsuario(null);
      cargarDatosGuia();
      setPaso(5);
    };
    
    inicializar();
  }, [isAuthenticated, trabajador]);

  // Paso 1: Verificar matrícula y DNI
  const handleVerificarMatricula = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/beneficios/verificar-matricula`, {
        matricula,
        documento
      });

      if (response.data.existe) {
        // Cargar datos existentes en el formulario
        const trab = response.data.trabajador;
        setFormData({
          numero_matricula: trab.numero_matricula || matricula,
          documento: trab.documento || documento,
          apellido: trab.apellido || '',
          nombre: trab.nombre || '',
          fecha_nacimiento: fechaToInput(trab.fecha_nacimiento) || '',
          genero: trab.genero || '',
          titulo: trab.titulo || '',
          email: trab.email || '',
          celular: trab.celular || '',
          domicilio_real: trab.domicilio_real || { calle: '', numero: '', piso: '', depto: '', localidad: '' },
          domicilio_laboral: trab.domicilio_laboral || { calle: '', numero: '', piso: '', depto: '', localidad: '' },
          sin_empleo: trab.sin_empleo || false
        });
        
        // Verificar si tiene todos los datos obligatorios completos
        if (response.data.datos_completos) {
          // Tiene todos los datos, verificar directamente en ANTUAR
          setPaso(3);
          await verificarEnAntuar(matricula, documento);
        } else {
          // Faltan datos, mostrar formulario para completar
          setPaso(2);
        }
      } else {
        setError('Tus datos no se encuentran en el padrón del colegio. Por favor comunicate con el Colegio Distrital para regularizar tu situación.');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al verificar');
    } finally {
      setLoading(false);
    }
  };

  // Paso 2: Guardar datos y verificar en ANTUAR
  const handleGuardarDatos = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      // Convertir fecha al formato dd/mm/yyyy para guardar
      const dataToSave = {
        ...formData,
        fecha_nacimiento: fechaToDisplay(formData.fecha_nacimiento)
      };
      
      await axios.post(`${API_URL}/beneficios/guardar-datos`, {
        matricula: formData.numero_matricula,
        documento: formData.documento,
        data: dataToSave
      });
      
      // Ahora verificar en ANTUAR
      setPaso(3);
      await verificarEnAntuar(formData.numero_matricula, formData.documento);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar datos');
      setLoading(false);
    }
  };

  // Verificar acceso en ANTUAR
  const verificarEnAntuar = async (mat, doc) => {
    try {
      const response = await axios.post(`${API_URL}/beneficios/verificar-acceso-antuar`, {
        matricula: mat,
        documento: doc
      });
      
      if (response.data.puede_acceder) {
        const trabajadorConEstado = { ...response.data.trabajador, al_dia: true };
        setUsuario(trabajadorConEstado);
        sessionStorage.setItem('beneficios_usuario', JSON.stringify(trabajadorConEstado));
        await cargarDatosGuia();
        setPaso(5); // guia
      } else {
        // No está al día: entra igual al modo "no al día" (ve todo pero sin CTAs)
        const trabajadorNoAlDia = {
          ...(response.data.trabajador || {}),
          matricula: mat,
          documento: doc,
          al_dia: false,
          mensaje_deuda: response.data.mensaje,
          deuda_info: response.data.deuda_info,
        };
        setUsuario(trabajadorNoAlDia);
        setMensajeDeuda(response.data.mensaje);
        sessionStorage.setItem('beneficios_usuario', JSON.stringify(trabajadorNoAlDia));
        await cargarDatosGuia();
        setPaso(5); // guia (modo no al día)
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al verificar acceso');
      setPaso(2);
    } finally {
      setLoading(false);
    }
  };

  const cargarDatosGuia = async () => {
    setLoadingDatos(true);
    // Cargar en paralelo, cada endpoint con su propio catch para que uno que falle
    // no rompa la carga completa (ej: destacados fallando no debería dejar la home vacía).
    const [catRes, prestRes, popRes, destRes] = await Promise.all([
      axios.get(`${API_URL}/beneficios/categorias`).catch((e) => { console.warn('Error categorias:', e); return { data: [] }; }),
      axios.get(`${API_URL}/beneficios/prestadores`).catch((e) => { console.warn('Error prestadores:', e); return { data: [] }; }),
      axios.get(`${API_URL}/beneficios/prestadores/populares?limit=8`).catch(() => ({ data: [] })),
      axios.get(`${API_URL}/beneficios/prestadores/destacados?limit=8`).catch(() => ({ data: [] })),
    ]);
    setCategorias(catRes.data || []);
    setPrestadores(prestRes.data || []);
    setPopulares(popRes.data || []);
    setDestacados(destRes.data || []);
    setLoadingDatos(false);
  };

  const generarVoucher = async (prestadorId = null) => {
    setGenerandoVoucher(prestadorId || 'general');
    setError(null);
    try {
      const response = await axios.post(
        `${API_URL}/beneficios/generar-voucher`,
        {
          matricula: usuario?.matricula || formData.numero_matricula,
          documento: usuario?.documento || formData.documento,
          prestador_id: prestadorId
        },
        { responseType: 'blob' }
      );
      
      const contentType = response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        setError(errorData.detail || 'Error al generar el voucher');
        return;
      }
      
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const prestadorNombre = prestadorId 
        ? prestadores.find(p => p.id === prestadorId)?.nombre?.replace(/\s+/g, '_') || prestadorId
        : 'general';
      link.setAttribute('download', `voucher_${prestadorNombre}_${usuario?.matricula || formData.numero_matricula}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error generando voucher:', err);
      setError(err.response?.data?.detail || 'Error al generar el voucher');
    } finally {
      setGenerandoVoucher(null);
    }
  };

  const updateFormData = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Función para vincular usuario y mostrar código de descuento
  const vincularYMostrarCodigo = async (prestador) => {
    setVinculando(true);
    setCodigoDescuento(null);
    
    // Simular proceso de vinculación (2 segundos)
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setCodigoDescuento({
      codigo: prestador.codigo_descuento,
      prestador: prestador.nombre,
      usuario: usuario?.nombre || `${formData.nombre} ${formData.apellido}`,
      matricula: usuario?.matricula || formData.numero_matricula
    });
    setVinculando(false);
    setShowCodigoModal(true);
  };

  // Función para normalizar texto (quitar acentos)
  const normalizarTexto = (texto) => {
    if (!texto) return '';
    return texto
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  // Capitalizar texto para mostrar
  const capitalizarTexto = (texto) => {
    if (!texto) return '';
    return texto.trim().split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  };

  // Obtener listas únicas de provincias y localidades (normalizadas)
  const provincias = React.useMemo(() => {
    const map = new Map(); // key: normalizado, value: texto original capitalizado
    prestadores.forEach(p => {
      if (p.provincia?.trim()) {
        const normalizado = normalizarTexto(p.provincia);
        if (!map.has(normalizado)) {
          map.set(normalizado, capitalizarTexto(p.provincia));
        }
      }
    });
    return Array.from(map.values()).sort();
  }, [prestadores]);

  const localidades = React.useMemo(() => {
    const map = new Map();
    prestadores.forEach(p => {
      // Si hay filtro de provincia, solo mostrar localidades de esa provincia
      if (provinciaFiltro && normalizarTexto(p.provincia) !== normalizarTexto(provinciaFiltro)) return;
      if (p.localidad?.trim()) {
        const normalizado = normalizarTexto(p.localidad);
        if (!map.has(normalizado)) {
          map.set(normalizado, capitalizarTexto(p.localidad));
        }
      }
    });
    return Array.from(map.values()).sort();
  }, [prestadores, provinciaFiltro]);

  // Filtrar prestadores por categoría, provincia, localidad y búsqueda
  const prestadoresFiltrados = prestadores.filter(p => {
    // Filtro por categoría
    if (categoriaFiltro && p.categoria_id !== categoriaFiltro) {
      return false;
    }
    
    // Filtro por provincia (comparación normalizada)
    if (provinciaFiltro && normalizarTexto(p.provincia) !== normalizarTexto(provinciaFiltro)) {
      return false;
    }
    
    // Filtro por localidad (comparación normalizada)
    if (localidadFiltro && normalizarTexto(p.localidad) !== normalizarTexto(localidadFiltro)) {
      return false;
    }
    
    // Filtro por origen (turismo social / directo)
    if (origenFiltro && p.origen !== origenFiltro) {
      return false;
    }
    
    // Filtro por búsqueda (sin sensibilidad a acentos)
    if (busqueda.trim()) {
      const termino = normalizarTexto(busqueda.trim());
      const nombreMatch = normalizarTexto(p.nombre).includes(termino);
      const descripcionMatch = normalizarTexto(p.descripcion).includes(termino);
      const beneficioMatch = normalizarTexto(p.beneficio).includes(termino);
      const categoriaMatch = normalizarTexto(p.categoria_nombre).includes(termino);
      // Búsqueda por ubicación: incluye ubicacion, direccion, localidad y provincia
      const ubicacionMatch = normalizarTexto(p.ubicacion).includes(termino);
      const direccionMatch = normalizarTexto(p.direccion).includes(termino);
      const localidadMatch = normalizarTexto(p.localidad).includes(termino);
      const provinciaMatch = normalizarTexto(p.provincia).includes(termino);
      // Búsqueda por destino: matchea títulos y subtítulos de paquetes turísticos
      const paquetesMatch = Array.isArray(p.paquetes) && p.paquetes.some(paq =>
        normalizarTexto(paq?.titulo).includes(termino) ||
        normalizarTexto(paq?.descripcion_corta).includes(termino) ||
        normalizarTexto(paq?.descripcion_larga).includes(termino)
      );
      
      return nombreMatch || descripcionMatch || beneficioMatch || categoriaMatch || 
             ubicacionMatch || direccionMatch || localidadMatch || provinciaMatch ||
             paquetesMatch;
    }
    
    return true;
  });

  // ===================== PASO 0: Cargando =====================
  if (paso === 0) {
    return (
      <div className="min-h-screen bg-[#f3f0fd] flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-purple-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  // ===================== PASO 3: Verificando en ANTUAR =====================
  if (paso === 3) {
    return (
      <div className="min-h-screen bg-[#f3f0fd] flex items-center justify-center">
        <Card className="max-w-md mx-4">
          <CardContent className="pt-8 pb-8 text-center">
            <Loader2 className="w-16 h-16 text-purple-600 animate-spin mx-auto mb-6" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Verificando si te encontrás al día en tu matrícula
            </h2>
            <p className="text-gray-500">Consultando estado...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  // ===================== PASO 4: Sin acceso (tiene deuda) =====================
  if (paso === 4) {
    return (
      <div className="min-h-screen bg-[#f3f0fd]">
        <UserHeader />
        
        <main className="max-w-lg mx-auto px-4 py-8">
          <Button variant="ghost" onClick={() => goBack()} className="mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver
          </Button>
          
          <Card className="border-amber-200">
            <CardContent className="pt-8 pb-8 text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <AlertCircle className="w-8 h-8 text-amber-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Acceso no disponible
              </h2>
              <p className="text-gray-600 mb-6">
                Nuestro sistema detecta que no estás al día en el pago de tu matrícula. 
                Para acceder a los beneficios, regularizá tu deuda en el Portal ANTUAR.
              </p>
              
              <div className="space-y-3">
                <Button asChild className="w-full bg-purple-600 hover:bg-purple-700">
                  <a href="https://www.antuar.com.ar/catspba" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="w-4 h-4 mr-2" />
                    Ir al Portal ANTUAR
                  </a>
                </Button>
                
                <Button variant="outline" className="w-full" onClick={() => navigate('/estado-cuenta')}>
                  <Wallet className="w-4 h-4 mr-2" />
                  Ver mi Estado de Cuenta
                </Button>
              </div>
              
              <p className="text-sm text-gray-500 mt-6">
                Si creés que esto es un error, comunicate con el Colegio Distrital.
              </p>
            </CardContent>
          </Card>
        </main>
      </div>
    );
  }

  // ===================== PASO 1: Login =====================
  if (paso === 1) {
    return (
      <div className="min-h-screen bg-[#f3f0fd]">
        <UserHeader />
        
        <main className="max-w-lg mx-auto px-4 py-8">
          <Button variant="ghost" onClick={() => goBack()} className="mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver
          </Button>
          
          <Card>
            <CardHeader className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Gift className="w-8 h-8 text-purple-600" />
              </div>
              <CardTitle className="text-2xl">Guía de Beneficios TS+</CardTitle>
              <p className="text-gray-500 mt-2">
                Accedé a descuentos exclusivos en hotelería, transporte, indumentaria y más.
              </p>
              {isAuthenticated && (
                <p className="text-sm text-amber-600 mt-2 bg-amber-50 p-2 rounded">
                  Estás logueado pero necesitamos verificar tus datos de matrícula.
                </p>
              )}
            </CardHeader>
            
            <CardContent>
              <form onSubmit={handleVerificarMatricula} className="space-y-4">
                <div>
                  <Label htmlFor="matricula">Número de Matrícula</Label>
                  <Input
                    id="matricula"
                    placeholder="Ej: 12345"
                    value={matricula}
                    onChange={(e) => setMatricula(e.target.value)}
                    required
                    data-testid="beneficios-matricula-input"
                  />
                </div>
                
                <div>
                  <Label htmlFor="documento">DNI (sin puntos)</Label>
                  <Input
                    id="documento"
                    placeholder="Ej: 30123456"
                    value={documento}
                    onChange={(e) => setDocumento(e.target.value)}
                    required
                    data-testid="beneficios-documento-input"
                  />
                </div>
                
                {error && (
                  <div className="p-3 bg-red-100 border border-red-300 rounded-lg flex items-center gap-2 text-red-700">
                    <AlertCircle className="w-4 h-4 flex-shrink-0" />
                    <span className="text-sm">{error}</span>
                  </div>
                )}
                
                <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700" disabled={loading}>
                  {loading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Verificando...
                    </>
                  ) : (
                    <>
                      Continuar
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </>
                  )}
                </Button>
              </form>
              
              <p className="text-xs text-gray-500 text-center mt-4">
                Solo pueden acceder matriculados/as que se encuentren al día con sus obligaciones.
              </p>
            </CardContent>
          </Card>
        </main>
      </div>
    );
  }

  // ===================== PASO 2: Completar Datos =====================
  if (paso === 2) {
    return (
      <div className="min-h-screen bg-[#f3f0fd]">
        <UserHeader />
        
        <main className="max-w-2xl mx-auto px-4 py-8">
          <Button variant="ghost" onClick={() => setPaso(1)} className="mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver
          </Button>
          
          <Card>
            <CardHeader>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                  <Gift className="w-6 h-6 text-purple-600" />
                </div>
                <div>
                  <CardTitle className="text-xl">Verificá tus datos</CardTitle>
                  <p className="text-sm text-gray-500">Guía de Beneficios TS+</p>
                </div>
              </div>
            </CardHeader>
            
            <CardContent>
              {/* Mensaje para usuarios precargados */}
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
                <p className="text-amber-800 font-medium mb-1">
                  ¡Hola {formData.nombre || ''} {formData.apellido || ''}!
                </p>
                <p className="text-sm text-amber-700">
                  Para acceder a la Guía de Beneficios necesitamos que completes todos tus datos.
                  <strong> Todos los campos marcados con * son obligatorios.</strong>
                </p>
              </div>

              <form onSubmit={handleGuardarDatos} className="space-y-8">
                {error && (
                  <div className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    <AlertCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
                    {error}
                  </div>
                )}

                {/* Datos Básicos */}
                <div>
                  <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                    <User className="w-5 h-5 text-purple-600" />
                    Datos Básicos
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label>Número de Matrícula</Label>
                      <Input value={formData.numero_matricula} readOnly className="bg-gray-50" />
                    </div>
                    <div className="space-y-2">
                      <Label>Documento</Label>
                      <Input value={formData.documento} readOnly className="bg-gray-50" />
                    </div>
                    <div className="space-y-2">
                      <Label>Apellido *</Label>
                      <Input value={formData.apellido} onChange={(e) => updateFormData('apellido', e.target.value)} required />
                    </div>
                    <div className="space-y-2">
                      <Label>Nombre *</Label>
                      <Input value={formData.nombre} onChange={(e) => updateFormData('nombre', e.target.value)} required />
                    </div>
                    <div className="space-y-2">
                      <Label>Fecha de Nacimiento *</Label>
                      <Input type="date" value={formData.fecha_nacimiento} onChange={(e) => updateFormData('fecha_nacimiento', e.target.value)} required />
                    </div>
                    <div className="space-y-2">
                      <Label>Género</Label>
                      <select 
                        value={formData.genero} 
                        onChange={(e) => updateFormData('genero', e.target.value)}
                        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                      >
                        <option value="">Seleccionar</option>
                        {GENEROS.map(g => <option key={g} value={g}>{g}</option>)}
                      </select>
                    </div>
                    <div className="space-y-2">
                      <Label>Título *</Label>
                      <select 
                        value={formData.titulo} 
                        onChange={(e) => updateFormData('titulo', e.target.value)}
                        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                        required
                      >
                        <option value="">Seleccionar</option>
                        <optgroup label="Titulaciones vigentes">
                          {TITULOS_VIGENTES.map(t => <option key={t} value={t}>{t}</option>)}
                        </optgroup>
                        <optgroup label="Titulaciones anteriores">
                          {TITULOS_ANTERIORES.map(t => <option key={t} value={t}>{t}</option>)}
                        </optgroup>
                      </select>
                    </div>
                    <div className="space-y-2">
                      <Label>Email *</Label>
                      <Input type="email" value={formData.email} onChange={(e) => updateFormData('email', e.target.value)} required />
                    </div>
                    <div className="space-y-2 md:col-span-2">
                      <Label>Celular *</Label>
                      <Input value={formData.celular} onChange={(e) => updateFormData('celular', e.target.value)} required />
                    </div>
                  </div>
                </div>

                {/* Domicilio Real */}
                <div>
                  <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                    <MapPin className="w-5 h-5 text-purple-600" />
                    Domicilio Real
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="col-span-2 space-y-2">
                      <Label>Calle *</Label>
                      <Input value={formData.domicilio_real?.calle || ''} onChange={(e) => updateDomicilio('domicilio_real', 'calle', e.target.value)} required />
                    </div>
                    <div className="space-y-2">
                      <Label>Número *</Label>
                      <Input value={formData.domicilio_real?.numero || ''} onChange={(e) => updateDomicilio('domicilio_real', 'numero', e.target.value)} required />
                    </div>
                    <div className="space-y-2">
                      <Label>Piso</Label>
                      <Input value={formData.domicilio_real?.piso || ''} onChange={(e) => updateDomicilio('domicilio_real', 'piso', e.target.value)} />
                    </div>
                    <div className="space-y-2">
                      <Label>Depto</Label>
                      <Input value={formData.domicilio_real?.depto || ''} onChange={(e) => updateDomicilio('domicilio_real', 'depto', e.target.value)} />
                    </div>
                    <div className="col-span-2 md:col-span-3 space-y-2">
                      <Label>Localidad *</Label>
                      <Input value={formData.domicilio_real?.localidad || ''} onChange={(e) => updateDomicilio('domicilio_real', 'localidad', e.target.value)} required />
                    </div>
                  </div>
                </div>

                {/* Domicilio Laboral */}
                <div>
                  <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                    <Briefcase className="w-5 h-5 text-purple-600" />
                    Domicilio Laboral
                  </h3>
                  
                  {/* Checkbox sin empleo */}
                  <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                    <label className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.sin_empleo}
                        onChange={(e) => updateFormData('sin_empleo', e.target.checked)}
                        className="w-5 h-5 rounded border-amber-400 text-amber-600 focus:ring-amber-500"
                      />
                      <span className="text-amber-800 font-medium">Me encuentro actualmente sin empleo</span>
                    </label>
                  </div>

                  {!formData.sin_empleo && (
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <div className="col-span-2 space-y-2">
                        <Label>Calle *</Label>
                        <Input value={formData.domicilio_laboral?.calle || ''} onChange={(e) => updateDomicilio('domicilio_laboral', 'calle', e.target.value)} required={!formData.sin_empleo} />
                      </div>
                      <div className="space-y-2">
                        <Label>Número *</Label>
                        <Input value={formData.domicilio_laboral?.numero || ''} onChange={(e) => updateDomicilio('domicilio_laboral', 'numero', e.target.value)} required={!formData.sin_empleo} />
                      </div>
                      <div className="space-y-2">
                        <Label>Piso</Label>
                        <Input value={formData.domicilio_laboral?.piso || ''} onChange={(e) => updateDomicilio('domicilio_laboral', 'piso', e.target.value)} />
                      </div>
                      <div className="space-y-2">
                        <Label>Depto</Label>
                        <Input value={formData.domicilio_laboral?.depto || ''} onChange={(e) => updateDomicilio('domicilio_laboral', 'depto', e.target.value)} />
                      </div>
                      <div className="col-span-2 md:col-span-3 space-y-2">
                        <Label>Localidad *</Label>
                        <Input value={formData.domicilio_laboral?.localidad || ''} onChange={(e) => updateDomicilio('domicilio_laboral', 'localidad', e.target.value)} required={!formData.sin_empleo} />
                      </div>
                    </div>
                  )}

                  {formData.sin_empleo && (
                    <p className="text-sm text-gray-500 italic">Los campos de domicilio laboral no son requeridos cuando no tenés empleo actualmente.</p>
                  )}
                </div>

                <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700" disabled={loading}>
                  {loading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Guardando...
                    </>
                  ) : (
                    <>
                      Guardar y Continuar
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </>
                  )}
                </Button>
              </form>
            </CardContent>
          </Card>
        </main>
      </div>
    );
  }

  // ===================== PASO 5: Guía de Beneficios =====================
  return (
    <div className="min-h-screen bg-[#f3f0fd]">
      <UserHeader />
      
      {/* Botón volver */}
      <div className="max-w-6xl mx-auto px-4 pt-4">
        <Button variant="ghost" onClick={() => goBack()} className="text-gray-600 hover:text-gray-900">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver
        </Button>
      </div>
      
      {/* Banner TS+ */}
      <div className="max-w-3xl mx-auto mt-4 px-4">
        <img 
          src="/banner-ts-plus.png" 
          alt="Guía de Beneficios TS+" 
          className="w-full h-auto"
        />
      </div>
      
      <main className="max-w-6xl mx-auto px-4 py-8">
        
        {/* Header con info del usuario — 3 modos: público / no al día / al día(o admin) */}
        {usuario === null ? (
          // ===== MODO PÚBLICO =====
          <Card className="mb-6 border-gray-200 bg-white">
            <CardContent className="py-4">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
                    <Eye className="w-6 h-6 text-gray-500" />
                  </div>
                  <div>
                    <h1 className="text-lg font-bold text-gray-900">Estás en modo vidriera</h1>
                    <p className="text-sm text-gray-600">
                      Mirá todos los beneficios. Verificá tu matrícula para poder usarlos.
                    </p>
                  </div>
                </div>
                <Button
                  size="lg"
                  onClick={() => setShowUnlockModal(true)}
                  className="bg-gray-900 hover:bg-black text-white font-semibold rounded-xl"
                  data-testid="verificar-matricula-btn"
                >
                  <KeyRound className="w-4 h-4 mr-2" />
                  Verificar mi matrícula
                </Button>
              </div>
            </CardContent>
          </Card>
        ) : usuario.al_dia === false ? (
          // ===== MODO NO AL DÍA =====
          <Card className="mb-6 border-amber-300 bg-gradient-to-br from-amber-50 to-orange-50">
            <CardContent className="py-4">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center">
                    <Lock className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h1 className="text-lg font-bold text-amber-900">
                      Hola {(usuario.nombre || '').split(' ')[0] || 'colega'}, estás viendo lo que te estás perdiendo
                    </h1>
                    <p className="text-sm text-amber-800">
                      {usuario.mensaje_deuda || 'Tu matrícula no está al día. Regularizá tu situación para desbloquear los beneficios.'}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <a
                    href="https://servicios.colegiotslomas.org/estado-cuenta"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button
                      size="lg"
                      className="bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-xl"
                      data-testid="consultar-deuda-btn"
                    >
                      <HelpCircle className="w-4 h-4 mr-2" />
                      Ponerme al día
                    </Button>
                  </a>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="text-amber-700 hover:text-amber-900"
                    onClick={() => {
                      sessionStorage.removeItem('beneficios_usuario');
                      setUsuario(null);
                      setMensajeDeuda(null);
                    }}
                    data-testid="salir-no-al-dia-btn"
                  >
                    Salir
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ) : (
          // ===== MODO AL DÍA / ADMIN =====
          <Card className="mb-6 border-purple-200 bg-purple-50">
            <CardContent className="py-4">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center">
                    <Gift className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h1 className="text-xl font-bold text-gray-900">{usuario?.nombre}</h1>
                    <p className="text-sm text-gray-600">
                      {usuario?.es_admin ? 'Acceso de administrador' : `Matrícula: ${usuario?.matricula}`}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Badge className={usuario?.es_admin ? 'bg-indigo-600 text-white' : 'bg-purple-600 text-white'}>
                    <CheckCircle className="w-4 h-4 mr-1" />
                    {usuario?.es_admin ? 'Admin' : 'Al día'}
                  </Badge>
                  {!usuario?.es_admin && (
                    <Button 
                      variant="ghost" 
                      size="sm"
                      className="text-gray-500 hover:text-gray-700"
                      onClick={() => {
                        sessionStorage.removeItem('beneficios_usuario');
                        setUsuario(null);
                      }}
                    >
                      Cerrar sesión
                    </Button>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        )}

        {/* HERO BANNER promocional */}
        <HeroBannerTS
          eyebrow="Guía TS+"
          titulo={`Hola ${(usuario?.nombre || '').split(' ')[0] || 'colega'}, descubrí tus beneficios`}
          subtitulo="Cientos de descuentos, cupones y promociones en turismo, gastronomía, salud, indumentaria y más. Todo por ser parte del Colegio."
          ctaLabel="Ver todos los beneficios"
          onCta={() => {
            setCategoriaFiltro(null);
            setOrigenFiltro(null);
            listaCompletaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
        />

        {/* Buscador + Accesos rápidos + Categorías */}
        <div className="mb-8 space-y-6">
          {/* Buscador prominente */}
          <div className="relative max-w-3xl mx-auto">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
            <input
              type="text"
              placeholder="Buscar por prestador, destino (Bariloche, Iguazú...), rubro o ciudad…"
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              className="w-full h-14 pl-12 pr-12 rounded-2xl border-2 border-purple-200 bg-white text-base shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-100 focus:border-purple-500 transition-all"
              data-testid="beneficios-search"
            />
            {busqueda && (
              <button
                onClick={() => setBusqueda('')}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700"
                aria-label="Limpiar búsqueda"
              >
                <X className="w-5 h-5" />
              </button>
            )}
          </div>

          {/* Accesos rápidos: Novedades / Destacados / Más usados / Turismo / Todos */}
          <AccesosRapidos
            onSelect={(id) => {
              // Limpiar filtros de búsqueda al hacer click
              setBusqueda('');
              if (id === 'turismo') {
                setOrigenFiltro('rueda_turismo');
                setCategoriaFiltro(null);
                listaCompletaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                return;
              }
              // Los otros llevan a la sección correspondiente
              setOrigenFiltro(null);
              setCategoriaFiltro(null);
              setProvinciaFiltro(null);
              setLocalidadFiltro(null);
              const map = {
                novedades: novedadesRef,
                destacados: destacadosRef,
                populares: popularesRef,
                todos: listaCompletaRef,
              };
              map[id]?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
          />

          {/* Categorías en carrusel circular */}
          {loadingDatos && categorias.length === 0 ? (
            <div>
              <div className="flex items-baseline justify-between mb-3">
                <h2 className="text-lg font-semibold text-gray-900">Explorá cupones por categoría</h2>
              </div>
              <div className="flex gap-3 sm:gap-4 pb-2 overflow-hidden">
                {Array.from({ length: 8 }).map((_, i) => (
                  <div key={`cat-skel-${i}`} className="flex flex-col items-center gap-2 flex-shrink-0 w-20 sm:w-24 animate-pulse">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-purple-100" />
                    <div className="h-3 bg-gray-200 rounded w-14" />
                  </div>
                ))}
              </div>
            </div>
          ) : categorias.length > 0 && (
            <div>
              <div className="flex items-baseline justify-between mb-3">
                <h2 className="text-lg font-semibold text-gray-900">Explorá cupones por categoría</h2>
                {(categoriaFiltro !== null || origenFiltro) && (
                  <button
                    onClick={() => { setCategoriaFiltro(null); setOrigenFiltro(null); }}
                    className="text-xs text-purple-600 hover:underline"
                    data-testid="reset-categoria"
                  >
                    Ver todas
                  </button>
                )}
              </div>
              <CategoriasCarrusel
                categorias={categorias}
                categoriaFiltro={categoriaFiltro}
                onSelect={(id) => {
                  setCategoriaFiltro(id);
                  setOrigenFiltro(null);
                  if (id) {
                    setTimeout(() => {
                      listaCompletaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 100);
                  }
                }}
                iconMap={iconMap}
              />
            </div>
          )}

          {/* Filtros secundarios (ubicación) colapsables */}
          {(provincias.length > 0 || localidades.length > 0) && (
            <details className="group bg-white rounded-xl border border-gray-200 open:shadow-sm">
              <summary className="cursor-pointer flex items-center justify-between px-4 py-3 text-sm font-medium text-gray-700 select-none list-none">
                <span className="flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-gray-500" />
                  Filtrar por ubicación
                  {(provinciaFiltro || localidadFiltro) && (
                    <Badge className="ml-2 bg-purple-100 text-purple-700 text-[10px]">
                      {[provinciaFiltro, localidadFiltro].filter(Boolean).join(' · ')}
                    </Badge>
                  )}
                </span>
                <ArrowRight className="w-4 h-4 text-gray-400 transition-transform group-open:rotate-90" />
              </summary>
              <div className="px-4 pb-4 pt-1 flex flex-wrap items-center gap-3 border-t border-gray-100">
                {provincias.length > 0 && (
                  <div className="flex items-center gap-2">
                    <Label className="text-xs text-gray-600">Provincia</Label>
                    <Select
                      value={provinciaFiltro || "todas"}
                      onValueChange={(v) => {
                        setProvinciaFiltro(v === "todas" ? null : v);
                        setLocalidadFiltro(null);
                      }}
                    >
                      <SelectTrigger className="w-[180px] h-9"><SelectValue placeholder="Todas" /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="todas">Todas</SelectItem>
                        {provincias.map((prov) => <SelectItem key={prov} value={prov}>{prov}</SelectItem>)}
                      </SelectContent>
                    </Select>
                  </div>
                )}
                {localidades.length > 0 && (
                  <div className="flex items-center gap-2">
                    <Label className="text-xs text-gray-600">Localidad</Label>
                    <Select
                      value={localidadFiltro || "todas"}
                      onValueChange={(v) => setLocalidadFiltro(v === "todas" ? null : v)}
                    >
                      <SelectTrigger className="w-[220px] h-9"><SelectValue placeholder="Todas" /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="todas">Todas</SelectItem>
                        {localidades.map((loc) => <SelectItem key={loc} value={loc}>{loc}</SelectItem>)}
                      </SelectContent>
                    </Select>
                  </div>
                )}
                {(provinciaFiltro || localidadFiltro) && (
                  <Button variant="ghost" size="sm"
                    onClick={() => { setProvinciaFiltro(null); setLocalidadFiltro(null); }}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <X className="w-4 h-4 mr-1" /> Limpiar
                  </Button>
                )}
              </div>
            </details>
          )}

          {/* Contador de resultados (solo cuando hay filtros activos) */}
          {(busqueda || categoriaFiltro || provinciaFiltro || localidadFiltro || origenFiltro) && (
            <p className="text-sm text-gray-500 text-center">
              <strong className="text-gray-800">{prestadoresFiltrados.length}</strong>{' '}
              {prestadoresFiltrados.length === 1 ? 'resultado' : 'resultados'}
              {busqueda && <span> para "{busqueda}"</span>}
              {origenFiltro === 'rueda_turismo' && <span> en Turismo Social</span>}
              {localidadFiltro && <span> en {localidadFiltro}</span>}
              {provinciaFiltro && !localidadFiltro && <span> en {provinciaFiltro}</span>}
            </p>
          )}
        </div>

        {/* Carrusel de Novedades (últimos 8 por created_at, se oculta si hay filtros activos) */}
        {!busqueda && !categoriaFiltro && !provinciaFiltro && !localidadFiltro && !origenFiltro && prestadores.length > 0 && (() => {
          const novedades = [...prestadores]
            .filter(p => p.created_at)
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .slice(0, 8);
          if (novedades.length === 0) return null;
          return (
            <section ref={novedadesRef} className="mb-8 scroll-mt-24" data-testid="novedades-section">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2">
                  <Sparkles className="w-5 h-5 text-amber-500" />
                  Novedades
                </h2>
                <span className="text-xs text-gray-500">últimos incorporados</span>
              </div>
              <div className="overflow-x-auto -mx-2 px-2 pb-3 scrollbar-thin">
                <div className="flex gap-3 sm:gap-4 min-w-max">
                  {novedades.map((p) => (
                    <div key={`nov-${p.id}`} className="w-56 flex-shrink-0">
                      <PrestadorCardBonda
                        prestador={p}
                        categoriaIcon={iconMap[categorias.find(c => c.id === p.categoria_id)?.icono]}
                        onClick={() => navigate(`/beneficios/prestador/${p.id}`)}
                        badge="NUEVO"
                        badgeClass="bg-amber-500"
                        testId={`novedad-${p.id}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </section>
          );
        })()}

        {/* Carruseles curados: Destacados + Más usados (sólo cuando no hay filtros) */}
        {!busqueda && !categoriaFiltro && !provinciaFiltro && !localidadFiltro && !origenFiltro && (
          <>
            {destacados.length > 0 && (
              <section ref={destacadosRef} className="mb-8 scroll-mt-24" data-testid="destacados-section">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2">
                    <Star className="w-5 h-5 text-purple-500" />
                    Destacados
                  </h2>
                  <span className="text-xs text-gray-500">elegidos por el Colegio</span>
                </div>
                <div className="overflow-x-auto -mx-2 px-2 pb-3 scrollbar-thin">
                  <div className="flex gap-3 sm:gap-4 min-w-max">
                    {destacados.map((p) => (
                      <div key={`dest-${p.id}`} className="w-56 flex-shrink-0">
                        <PrestadorCardBonda
                          prestador={p}
                          categoriaIcon={iconMap[categorias.find(c => c.id === p.categoria_id)?.icono]}
                          onClick={() => navigate(`/beneficios/prestador/${p.id}`)}
                          badge="DESTACADO"
                          badgeClass="bg-purple-600"
                          testId={`destacado-${p.id}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            )}
            {populares.length > 0 && (
              <section ref={popularesRef} className="mb-8 scroll-mt-24" data-testid="populares-section">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2">
                    <TrendingUp className="w-5 h-5 text-emerald-500" />
                    Los más usados
                  </h2>
                  <span className="text-xs text-gray-500">últimos 90 días</span>
                </div>
                <div className="overflow-x-auto -mx-2 px-2 pb-3 scrollbar-thin">
                  <div className="flex gap-3 sm:gap-4 min-w-max">
                    {populares.map((p) => (
                      <div key={`pop-${p.id}`} className="w-56 flex-shrink-0">
                        <PrestadorCardBonda
                          prestador={p}
                          categoriaIcon={iconMap[categorias.find(c => c.id === p.categoria_id)?.icono]}
                          onClick={() => navigate(`/beneficios/prestador/${p.id}`)}
                          showCounter
                          testId={`popular-${p.id}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            )}
          </>
        )}

        {/* Error message */}
        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-300 rounded-lg flex items-center gap-2 text-red-700">
            <AlertCircle className="w-4 h-4" />
            <span className="text-sm">{error}</span>
            <button onClick={() => setError(null)} className="ml-auto">
              <X className="w-4 h-4" />
            </button>
          </div>
        )}

        {/* Lista completa de prestadores */}
        <section ref={listaCompletaRef} className="scroll-mt-24">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2">
              <Gift className="w-5 h-5 text-purple-600" />
              {(busqueda || categoriaFiltro || provinciaFiltro || localidadFiltro || origenFiltro)
                ? 'Resultados'
                : 'Todos los beneficios'}
            </h2>
            <span className="text-xs text-gray-500">
              {loadingDatos
                ? 'Cargando…'
                : `${prestadoresFiltrados.length} ${prestadoresFiltrados.length === 1 ? 'prestador' : 'prestadores'}`}
            </span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
            {loadingDatos
              ? Array.from({ length: 8 }).map((_, i) => (
                  <PrestadorCardSkeleton key={`skel-${i}`} testId={`prestador-skeleton-${i}`} />
                ))
              : prestadoresFiltrados.map((prestador) => (
                <PrestadorCardBonda
                  key={prestador.id}
                  prestador={prestador}
                  categoriaIcon={iconMap[categorias.find(c => c.id === prestador.categoria_id)?.icono]}
                  onClick={() => navigate(`/beneficios/prestador/${prestador.id}`)}
                  badge={prestador.origen === 'rueda_turismo' ? 'RUEDA TURISMO' : null}
                  badgeClass="bg-sky-600"
                  testId={`prestador-card-${prestador.id}`}
                />
              ))}
          </div>
        </section>

        {!loadingDatos && prestadoresFiltrados.length === 0 && (
          <Card>
            <CardContent className="py-12 text-center">
              <Gift className="w-12 h-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">No hay prestadores en esta categoría</p>
            </CardContent>
          </Card>
        )}

        {/* Nota informativa */}
        <Card className="mt-6 bg-blue-50 border-blue-200">
          <CardContent className="py-4">
            <div className="flex gap-3">
              <AlertCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <div className="text-sm text-blue-800">
                <p className="font-medium mb-1">¿Cómo usar los beneficios?</p>
                <ol className="list-decimal list-inside space-y-1 text-blue-700">
                  <li>Generá el voucher del prestador que te interesa</li>
                  <li>Contactá al prestador según el método indicado</li>
                  <li>Presentá el voucher al momento de usar el beneficio</li>
                  <li>El prestador puede verificar tu voucher escaneando el código QR</li>
                </ol>
              </div>
            </div>
          </CardContent>
        </Card>
      </main>

      {/* Modal Código de Descuento */}
      <Dialog open={showCodigoModal} onOpenChange={setShowCodigoModal}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-purple-600" />
              ¡Usuario vinculado correctamente!
            </DialogTitle>
          </DialogHeader>
          
          {codigoDescuento && (
            <div className="space-y-4">
              <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                <p className="text-sm text-gray-600">
                  <span className="font-medium">Usuario:</span> {codigoDescuento.usuario}
                </p>
                <p className="text-sm text-gray-600">
                  <span className="font-medium">Matrícula:</span> {codigoDescuento.matricula}
                </p>
                <p className="text-sm text-gray-600">
                  <span className="font-medium">Prestador:</span> {codigoDescuento.prestador}
                </p>
              </div>
              
              <div className="bg-purple-50 border-2 border-purple-200 rounded-lg p-6 text-center">
                <p className="text-sm text-purple-700 mb-2">Tu código de descuento es:</p>
                <p className="text-3xl font-bold text-purple-800 tracking-wider">
                  {codigoDescuento.codigo}
                </p>
              </div>
              
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                <p className="text-xs text-yellow-800">
                  <strong>Importante:</strong> Ingresá este código en la página del prestador al momento de realizar tu compra para aplicar el descuento.
                </p>
              </div>
              
              <Button 
                className="w-full"
                onClick={() => {
                  navigator.clipboard.writeText(codigoDescuento.codigo);
                  alert('¡Código copiado al portapapeles!');
                }}
              >
                Copiar código
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal para desbloquear (verificar matrícula) */}
      <UnlockBeneficiosModal
        open={showUnlockModal}
        onOpenChange={setShowUnlockModal}
        onUnlocked={(u) => {
          setUsuario(u);
          if (!u.al_dia) setMensajeDeuda(u.mensaje_deuda);
        }}
        motivo="usar los beneficios de la guía"
      />
    </div>
  );
}
